import React from "react";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import Breadcrumbs from "../components/Breadcrums";
import { FacilityData } from "../configs";

FacilityData.sort((a, b) => {
  if (a.isPinned && !b.isPinned) {
    return -1;
  } else if (!a.isPinned && b.isPinned) {
    return 1;
  } else {
    return b.description.length - a.description.length;
  }
});

const breadcrumbItems = [
  { label: "Home", path: "/" },
  { label: "Facilities", path: "/facilities" },
];

function Facilities() {
  return (
    <div className="flex flex-col justify-center lg:p-3">
      <Breadcrumbs items={breadcrumbItems} />
      <div className="text-sm text-primary-main mx-3 my-2 italic">
        Note: Facilities marked with * will only be available in specific room
        categories
      </div>
      <div className="flex flex-wrap gap-1 mb-3">
        {FacilityData.map((facility, index) => (
          <div
            key={index}
            className="flex flex-auto min-w-100 flex-col p-5
             bg-secondary-main rounded-lg border-primary-main hover:shadow-xl hover:bg-opacity-70"
          >
            <h2 className="text-lg font-bold text-primary-main">
              {facility.title}
            </h2>
            <div className="flex flex-col text-sm text-primary-main mt-2 gap-3">
              {facility.description.length > 1 ? (
                facility.description.map((desc, index) => (
                  <div key={index} className="flex flex-row gap-3">
                    <BeenhereIcon />
                    {desc}
                  </div>
                ))
              ) : (
                <span>{facility.description}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Facilities;
